module.exports = __webpack_public_path__ + "img/f6ff1da.png";